import { motion } from "framer-motion";

export default function KpiCard({ label, value, icon: Icon, accent = false, trend = null, testId }) {
  return (
    <motion.div
      data-testid={testId}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="bg-white rounded-2xl border border-slate-200 p-5 hover:border-slate-300 hover:shadow-sm transition-all"
    >
      <div className="flex items-start justify-between mb-3">
        <span className="text-xs font-semibold text-slate-500 uppercase tracking-wider">{label}</span>
        {Icon && (
          <div className={`w-9 h-9 rounded-xl flex items-center justify-center ${accent ? "bg-[#FFDF00]" : "bg-slate-100"}`}>
            <Icon className={`w-4.5 h-4.5 ${accent ? "text-[#1A1A1A]" : "text-slate-600"}`} strokeWidth={2.5} />
          </div>
        )}
      </div>
      <div className="text-3xl font-extrabold text-[#1A1A1A] font-display tracking-tight">
        {value}
      </div>
      {trend && (
        <div className="text-xs text-slate-500 mt-1">{trend}</div>
      )}
    </motion.div>
  );
}
